import React from 'react'
import { Row, Container } from 'react-bootstrap';
import './casestudybody55.css';

import clientimg from '../images/case-study-client55.webp'
import outcome from '../images/outcome55.webp'

import sm1 from '../images/cs55so1.webp'
import sm2 from '../images/cs55so2.webp'
import sm3 from '../images/cs55so3.webp'
import sm4 from '../images/cs55so4.webp'


const Casestudybody55 = () => {

    return (
        <>
        <section className='casestudybody55-section'  >
          <Container>

            <Row className='w-100 py-md-5 py-4 clintrow'>
                <div className='col-md-4 relative order-1'>
                  <div className='left-box'>
                    <div className='content-box'>
                      <h2>About</h2>
                      {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                      <div className="h1">The Client</div>
                      <p className='anima '><span className='only-anima-underline' > **** </span></p>
                      <p>A global venture capital firm investing in education, workforce development, and learning-driven technology companies, partnering closely with portfolio company founders to drive long-term growth and value creation</p>
                    </div>
                  </div>
                           
                </div>
                <div className='col-md-8 right-box'>
                    <img src={clientimg} alt="" />
                </div>
            </Row>
       
            <Row className='mt-md-5'>
              <div className='col-md-12'>
                <div className='content-box'>
                  <h2>Situation</h2>
                  {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                  <div className="h1">Overview</div>
                  <p className='anima '><span className='only-anima-underline' > **** </span></p>
                  <p>The client required a clear framework to assess exit outcomes for a portfolio company with a complex capital structure. The analysis evaluated shareholder payout distributions, preferred share conversion decisions, and the client's MOIC across different exit scenarios</p>
                </div>               
              </div>
            </Row>
          </Container>
        </section>
    
        <section className='casestudybody55-section bg-gredient-dark'>
          <Container>
            <Row>
              <div className='col-md-12'>
                  <div className='content-box'>
                    <h2>Approach &</h2>
                    {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                    <div className="h1">Methodology</div>
                    <p className='anima '><span className='only-anima-underline' > **** </span></p>
                    {/* <p>The next step was to put together and implement a step-by-step process for conducting the valuation:</p> */}
                    
                    <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4 span style={{color:"#03A393",fontWeight:700}}>Cap Table Reconstruction</h4>
                          <p>Reconstructed the fully diluted cap table, including all equity holders and convertible instruments, to establish accurate ownership positions</p>
                        </div>
                      </div>
    
                    <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4 span style={{color:"#03A393",fontWeight:700}}>Shareholder Rights Review</h4>
                          <p>Analysed governing documents to identify liquidation preferences, participation rights, dividend treatment, and conversion provisions</p>
                        </div>
                      </div>
    
                      <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4 span style={{color:"#03A393",fontWeight:700}}>Liquidation Waterfall Development</h4>
                          <p>Built a liquidation waterfall model to allocate exit proceeds based on shareholder priority and distribution rights</p>
                        </div>
                      </div>
    
                      <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>

                        <div className='text'>
                          <h4 span style={{color:"#03A393",fontWeight:700}}>Conversion Analysis</h4>
                          <p>Modelled preferred shareholder conversion decisions to determine the highest-value outcome across exit scenarios</p>
                        </div>
                      </div>

                      <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>

                        <div className='text'>
                          <h4 span style={{color:"#03A393",fontWeight:700}}>Exit Scenario Analysis</h4>
                          <p>Assessed multiple exit values to evaluate payout shifts, conversion triggers, and investor participation dynamics</p>
                        </div>

                        
                      </div>     
                          <div className='list-text last-child my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>

                        <div className='text'>
                          <h4 span style={{color:"#03A393",fontWeight:700}}>Return Calculations</h4>
                          <p>Calculated investor-level MOIC and return outcomes under different exit and distribution scenarios</p>
                        </div>

                        
                      </div>  

                  <div class="ai-section">

                    {/* <!-- Impact of AI --> */}
                    <div class="impact-panel">

                      <h2 class="section-heading">
                        <span class="heading-accent"></span>
                        Impact of AI
                      </h2>

                      <div class="impact-stat">
                        <span class="stat-arrow">▲</span>
                        <span class="stat-number">~60%</span>
                        <span class="stat-label">
                          Efficiency <br />
                          Increased
                        </span>
                      </div>

                      <div class="impact-stat">
                        <span class="stat-arrow">▲</span>
                        <span class="stat-number">~25%</span>
                        <span class="stat-label">
                          Accuracy<br />
                          Uplift
                        </span>
                      </div>

                    </div>

                    {/* <!-- AI Integration --> */}
                    <div class="integration-panel">

                      <h2 class="section-heading">
                        <span class="heading-accent"></span>
                        AI-Integration
                      </h2>

                      <div class="integration-content">

                        {/* <!-- How AI was used --> */}
                        <div class="integration-column">

                          <h3 class="column-heading">
                            TOOL DEPLOYED
                          </h3>

                          <p class="column-description">
                            Microsoft Copilot
                          </p>

                        </div>

                        {/* <!-- How AI was used --> */}
                        <div class="integration-column">

                          <h3 class="column-heading">
                            TECHNOLOGY
                          </h3>

                          <p class="column-description">
                            Generative AI / LLM, Prompt Engineering
                          </p>

                        </div>

                        {/* <!-- How AI was used --> */}
                        <div class="integration-column">

                          <h3 class="column-heading">
                            WHAT WE AUTOMATED
                          </h3>

                          <p class="column-description">
                            Automated extraction of cap table, liquidation and conversion terms across 30 charter documents, including share classes, preference rights, dividends, conversion criteria and exit conditions, with source references for analyst validation
                          </p>

                        </div>

                        {/* <!-- How AI was used --> */}
                        <div class="integration-column">

                          <h3 class="column-heading">
                            HUMAN QC LAYER
                          </h3>

                          <p class="column-description">
                            Validated AI-extracted information against the source charter documents, confirmed the applicable liquidation and conversion mechanics, and reviewed the final inputs integrating them with the company’s financials
                          </p>

                        </div>

                        {/* <!-- Delivery Benefits --> 
                        <div class="integration-column delivery-benefits">

                          <h3 class="column-heading">
                            DELIVERY BENEFITS
                          </h3>

                          <ul class="benefits-list">
                            <li>Faster build of templates, workflows, and UI components</li>
                            <li>Quicker prototype iterations during stakeholder validation</li>
                            <li>Wider test coverage from AI-prepared test cases</li>
                            <li>Consistent code patterns and current technical documentation</li>
                            <li>Less repetitive coding, more time on business logic</li>
                          </ul>

                        </div>*/}

                      </div>
                    </div>

                  </div>
                                        
                      <h3 className='mt-5'>Sample Output</h3>
                      <div className='sample-output mt-3'>
                        <img src={sm1} alt=''/>
                        <div className='sample-output1'>
                          <img src={sm2} alt=''/>
                          <img src={sm3} alt=''/>
                        </div>
                        <img src={sm4} alt=''/>
                      </div>
                  </div>
                  
                </div>
            </Row>

           


          </Container>
        </section>

    
        <section className='casestudybody55-section outcome'  >
          <Container>
            <Row className='w-100 pb-5 clintrow '>
                <div className='col-md-4 relative order-1'>
                  <div className='left-box'>
                    <div className='content-box'>
                      <div className="h1">Outcome</div>
                      <p className='anima '><span className='only-anima-underline' > **** </span></p>
                      <p>Delivered a Cap Table and Returns Waterfall framework translating complex ownership rights into transparent exit outcomes, enabling the client to test conversion decisions and investor payouts across various exit scenarios</p>  
                    </div>
                  </div>
                           
                </div>
                <div className='col-md-8 right-box'>
                    <img src={outcome} alt="" />
                </div>
            </Row>
       
          </Container>
        </section>
    
        </>  
      )
    }

export default Casestudybody55
